// =============================================================================
// FILE: frontend/src/modules/ppe/pages/mes/dashboard/ShopFloorDashboard.js
//
// MODULE: PPE → MES → Shopfloor Dashboard
//
// PURPOSE:
//   Operator-facing MES Shopfloor screen.
//
// RESPONSIVE UPGRADE (2026-02-26):
//   ✔ Desktop → Split layout
//   ✔ Tablet/Mobile → Vertical layout
//   ✔ Running executions prioritized on mobile
//   ✔ Resize-aware rendering
// =============================================================================

import React, { useState, useEffect } from "react";

// ⭐ MES PANELS
import ReadyOperationQueueV2 from "../components/ReadyOperationQueueV2";
import RunningExecutionBoard from "../components/RunningExecutionBoard";
import MESStatusBar from "../components/MESStatusBar";

const ShopFloorDashboard = () => {

  // ---------------------------------------------------------------------------
  // Responsive Detection
  // ---------------------------------------------------------------------------
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ---------------------------------------------------------------------------
  // Header Style (Industrial MES Theme)
  // ---------------------------------------------------------------------------
  const headerStyle = {
    background: "linear-gradient(90deg,#1f2937,#111827)",
    color: "#ffffff",
    padding: "18px 22px",
    borderRadius: "14px",
    marginBottom: "14px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
  };

  // ---------------------------------------------------------------------------
  // Panel Common Style
  // ---------------------------------------------------------------------------
  const panelStyle = {
    background: "#ffffff",
    borderRadius: "16px",
    padding: "16px",
    overflowY: isMobile ? "visible" : "auto",
    boxShadow: "0 8px 18px rgba(0,0,0,0.08)",
    border: "1px solid #e5e7eb",
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  return (
    <div
      style={{
        padding: "16px",
        minHeight: "100vh",
        background: "#eef2f6",
      }}
    >
      {/* ================= HEADER ================= */}
      <div style={headerStyle}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontWeight: 600,
              letterSpacing: "0.4px",
            }}
          >
            🏭 Shopfloor Control Dashboard
          </h2>

          <MESStatusBar />
        </div>
      </div>

      {/* ================= MAIN MES LAYOUT ================= */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "35% 65%",
          gap: "16px",
          height: isMobile ? "auto" : "calc(100vh - 150px)",
        }}
      >
        {/* ========================================================= */}
        {/* MOBILE → RUNNING FIRST (Operator Priority)                */}
        {/* ========================================================= */}
        {isMobile ? (
          <>
            <div style={panelStyle}>
              <RunningExecutionBoard />
            </div>

            <div style={panelStyle}>
              <ReadyOperationQueueV2 />
            </div>
          </>
        ) : (
          <>
            {/* READY PANEL */}
            <div style={panelStyle}>
              <ReadyOperationQueueV2 />
            </div>

            {/* RUNNING PANEL */}
            <div style={panelStyle}>
              <RunningExecutionBoard />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ShopFloorDashboard;